import Unit from "@/src/utils/constants/units";

export default {
  orderValue: [
    { key: 1, value: "Akıllı Sıralama", ga4Label: "akilli-siralama" },
    { key: 2, value: "Fiyat Azalan", ga4Label: "fiyat-once-en-yuksek" },
    { key: 3, value: "Fiyat Artan", ga4Label: "fiyat-once-en-dusuk" },
    { key: 4, value: "Tarihe Göre", ga4Label: "tarihe-gore" },
    { key: 5, value: `${Unit.M2.name} fiyatı azalan`, ga4Label: "m2-fiyati-once-en-dusuk" },
    { key: 6, value: `${Unit.M2.name} fiyatı artan`, ga4Label: "m2-fiyati-once-en-yuksek" },
  ],
};
